"use client";

import { useEffect } from "react";
import LogoutButton from "@/components/auth/LogoutButton";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-md rounded-xl border border-gray-200 bg-white p-8 text-center shadow-md dark:border-gray-800 dark:bg-gray-900">
        <h1 className="mb-2 text-2xl font-semibold">Something went wrong</h1>
        {error?.message ? (
          <p className="mb-6 text-sm text-gray-600 dark:text-gray-300">{error.message}</p>
        ) : (
          <p className="mb-6 text-sm text-gray-600 dark:text-gray-300">
            An unexpected error occurred. Please try again.
          </p>
        )}
        <div className="flex flex-col items-center gap-3">
          <button
            className="inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none dark:focus:ring-offset-gray-900"
            onClick={() => reset()}
          >
            Try again
          </button>
          <LogoutButton />
        </div>
      </div>
    </main>
  );
}
